import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/designTokens.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 👇 Import the AuthProvider
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AuthProvider } from './context/AuthContext';
import { OrderSocketProvider } from './context/OrderSocketContext';
import { store } from './store';

if (window.location.pathname.endsWith('/index.html')) {
  const appPath = window.location.pathname.slice(0, -'/index.html'.length) || '/';
  window.history.replaceState({}, '', `${appPath}${window.location.search}${window.location.hash}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <OrderSocketProvider>
            <App />
          </OrderSocketProvider>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
